import { createContext, useContext } from 'react';

export interface ErrorHandlerContextType {
  onError: (error: unknown) => void;
  onDismissError: () => void;
}

const ErrorHandlerContext = createContext<ErrorHandlerContextType>({
  onError: () => undefined,
  onDismissError: () => undefined,
});

export const useErrorHandlers = () => useContext(ErrorHandlerContext);

export default ErrorHandlerContext;
